<template>
  <BasePageSection
    class="bloak-page-section"
    :style="bgStyle"
    v-bind="{ ...$attrs, ...$props }"
    fluid
    px-0
  >
    <VLayout v-if="title" row justify-center>
      <VFlex xs12 md8>
        <h1 :style="titleStyle" :class="titleClass">
          <BasePageContent
            v-if="sectionName"
            :content-key="`${sectionName}_title`"
          />
          <template v-else>{{ title }}</template></h1
        >
      </VFlex>
    </VLayout>
    <slot />
  </BasePageSection>
</template>

<script>
export default {
  name: 'BlueOakPageSection',
  props: {
    type: {
      type: String,
      default: 'default',
    },
    title: {
      type: String,
      default: null,
    },
    titleColor: {
      type: String,
      default: null,
    },
    titleClass: {
      type: String,
      default: 'header-4 bloak-section--title',
    },
    bgColor: {
      type: String,
      default: null,
    },
    sectionName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    bgStyle() {
      let style = {}
      if (this.bgColor) {
        style['background-color'] = `${this.bgColor} !important`
      }
      return style
    }, // bgStyle
    titleStyle() {
      let style = {}
      if (this.titleColor) {
        style.color = `${this.titleColor} !important`
      }
      return style
    }, // titleStyle
  },
}
</script>

<style lang="scss">
@import '@design';

.bloak-page-section {
  color: $color-bloak-blue;
  background-color: $color-bloak-eggnog;
  .bloak-section--title {
    padding-bottom: 0.5em;
    border-bottom: 13px solid $color-bloak-piggy-pink;
  }
}
</style>
